export const APPROVE_ORDER = 'ORDER/APPROVE_ORDER';
export const CHANGE_DIALOG_STATE = 'ORDER/CHANGE_DIALOG_STATE';
export const CHANGE_PRESCRIPTION_STATE = 'ORDER/CHANGE_PRESCRIPTION_STATE';
export const CHANGE_SYNC_STATE = 'ORDER/CHANGE_SYNC_STATE';
export const LOAD_DATA = 'ORDER/LOAD_DATA';
export const REJECT_ORDER = 'ORDER/REJECT_ORDER';
export const DOWNLOAD_PDF = 'ORDER/DOWNLOAD_PDF';
export const BLOCKING_ORDER = 'ORDER/BLOCKING';
export const UNBLOCKING_ORDER = 'ORDER/UNBLOCKING';
